import React from 'react';

/**
 * MetricCard - Reusable card component for displaying a metric
 * @param {string} label - The metric label text
 * @param {string|number} value - The metric value
 * @param {string} badge - Optional badge text (e.g., "New")
 * @param {boolean} fullWidth - If true, card spans full width
 */
const MetricCard = ({ label, value, badge, fullWidth }) => (
    <div className={`metric-card ${fullWidth ? "full-width" : ""}`}>
        <div className="metric-label">
            {label}
            {badge && <span className="new-badge">{badge}</span>}
        </div>
        <div className="metric-value">{value}</div>
    </div>
);

export default MetricCard;
